export const TOP_BAR_SIZE = 52
export const OFFSET_AREA = 10
export const BEACON_OFFSET = 50

export const MAX_DESCRIPTION_WIDTH = 300
